import React from 'react';
import { Redirect, Switch, useRouteMatch } from 'react-router-dom';

import AuthorizedRoute from 'routes/AuthorizedRoute';
import { GAME_ADMIN_RESOURCES, GAME_ADMIN_SCOPES, PAGE_NAMES } from 'constant';

import Services from './submodules/services';
import Keys from './submodules/keys';
import Edit from './submodules/edit';
import CreateKey from './submodules/create';
import UpdateReqs from './submodules/updateReq';

const ZooKeeperPreProdDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={GAME_ADMIN_RESOURCES.zkPreProd}
				actions={[GAME_ADMIN_SCOPES[GAME_ADMIN_RESOURCES.zkPreProd].listServices]}
				configPageName={PAGE_NAMES.gameAdmin}
				path={`${path}/services`}
				component={Services}
				exact
			/>

			<AuthorizedRoute
				entity={GAME_ADMIN_RESOURCES.zkPreProd}
				actions={[GAME_ADMIN_SCOPES[GAME_ADMIN_RESOURCES.zkPreProd].listKeys]}
				configPageName={PAGE_NAMES.gameAdmin}
				path={`${path}/keys`}
				component={Keys}
				exact
			/>

			<AuthorizedRoute
				entity={GAME_ADMIN_RESOURCES.zookeeper}
				actions={[GAME_ADMIN_SCOPES[GAME_ADMIN_RESOURCES.zookeeper].getAllPendingZkUpdateReqs]}
				configPageName={PAGE_NAMES.gameAdmin}
				path={`${path}/getAllPendingZkUpdateReqs`}
				component={UpdateReqs}
				exact
			/>

			<AuthorizedRoute
				entity={GAME_ADMIN_RESOURCES.zookeeper}
				actions={[GAME_ADMIN_SCOPES[GAME_ADMIN_RESOURCES.zookeeper].getValueForKey]}
				configPageName={PAGE_NAMES.gameAdmin}
				path={`${path}/edit`}
				component={Edit}
				exact
			/>

			<AuthorizedRoute
				entity={GAME_ADMIN_RESOURCES.zookeeper}
				actions={[GAME_ADMIN_SCOPES[GAME_ADMIN_RESOURCES.zookeeper].updateKey]}
				configPageName={PAGE_NAMES.gameAdmin}
				path={`${path}/add`}
				component={CreateKey}
				exact
			/>

			<Redirect to={`${path}/services`} />
		</Switch>
	);
};

export default ZooKeeperPreProdDashboard;
